import React, { useEffect } from 'react';

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass, onToggleSidebar }: any) => {

    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header flex h-full items-center justify-between px-6">
                        <div className="flex items-center gap-2">
                            <button
                                onClick={onToggleSidebar}
                                type="button"
                                className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-slate-200 text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900 md:hidden"
                                aria-label="메뉴 열기"
                            >
                                <i className="ri-menu-line text-xl"></i>
                            </button>
                        </div>

                        <div className="flex items-center gap-2">

                            {/* LanguageDropdown */}
                            {/* <LanguageDropdown /> */}

                            {/* WebAppsDropdown */}
                            {/* <WebAppsDropdown /> */}

                            {/* MyCartDropdwon */}
                            {/* <MyCartDropdown /> */}

                            {/* FullScreenDropdown */}
                            {/* <FullScreenDropdown /> */}

                            {/* Dark/Light Mode set */}
                            {/* <LightDark
                                layoutMode={layoutModeType}
                                onChangeLayoutMode={onChangeLayoutMode}
                            /> */}

                            {/* NotificationDropdown */}
                            {/* <NotificationDropdown /> */}

                            {/* ProfileDropdown */}
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;
